import { gql } from 'graphql-tag';
import { GET_STUDENTS_BASE } from './getStudentsBase';
import type { IGetGroupsInfoData } from '../types';

export const GET_GROUPS_INFO = GET_STUDENTS_BASE<IGetGroupsInfoData>({
  student: gql`
    fragment Student on StudentType {
      id
      groupType
      waitListFlag
    }
  `,
});
